import React from 'react';
import { pick } from 'ramda';
import Tabs, { Tab } from '../../common/Tabs';
import { RACE_RULE_STATUSES } from '../../constants';
import Title from './CategoryTitle';
import style from './index.scss';

export const tabsClassNames = pick(['tabs', 'tab', 'active'], style);

export default ({ onChange, activeTab, tabs = [] }) => (
    <Tabs classNames={tabsClassNames} onChange={onChange} activeTab={activeTab}>
        {tabs.map(({ id, status, endDateTime: endTime, startDateTime: startTime }) => (
            <Tab
                key={id}
                value={id}
                className={`${status === RACE_RULE_STATUSES.approved ? style.upcoming : style.onAir}`}>
                <Title {...{ status, endTime, startTime }} />
            </Tab>
        ))}
    </Tabs>
);
